import { useCallback } from 'react';

import { Button } from '@bambi/component-library/src/components/Button/Button';

import { useAppDispatch, useAppSelector } from 'src/app/store/hooks';
import { ModalFooter } from 'src/common/primitives/Modal/ModalFooter';
import { routeTemplateActions } from 'src/features/trip/routeTemplates/routeTemplates.slice';

import { UnassignedTripsDataGrid } from '../datagrid/UnassignedTripsDataGrid';

interface ApplyRouteTemplatesStep2Props {
  onBack: () => void;
  onClose: () => void;
}
export function ApplyRouteTemplatesStep2({
  onBack,
  onClose,
}: ApplyRouteTemplatesStep2Props) {
  const dispatch = useAppDispatch();

  const applyRouteTemplatesResult = useAppSelector(
    (state) => state.routeTemplates.applyRouteTemplatesResult
  );

  const handleClose = useCallback(() => {
    dispatch(routeTemplateActions.setWorkflow('single'));
    dispatch(routeTemplateActions.selectAssignment(undefined));
    dispatch(routeTemplateActions.resetSelectedTrips());
    dispatch(routeTemplateActions.setApplyRouteTemplatesResult(null));
    onClose();
  }, [dispatch, onClose]);

  if (!applyRouteTemplatesResult) {
    return (
      <div className="flex items-center justify-center">
        No results found, go back and try again.
        <ModalFooter>
          <Button onClick={onBack}>Back</Button>
        </ModalFooter>
      </div>
    );
  }

  const assignedTripsCount = applyRouteTemplatesResult.assigned_trips.reduce(
    (acc, trip) => acc + trip.details.length,
    0
  );

  return (
    <div className="mt-2 flex flex-col gap-2">
      <div>
        Below are the results of applying the route templates, any trips that
        were successfully assigned are already updated on your dispatch
        calendar.
      </div>

      <div className="flex flex-col gap-2">
        {applyRouteTemplatesResult.assigned_trips.length ? (
          <div className="flex flex-col items-center">
            <span className="text-lg font-medium">
              {assignedTripsCount} trips assigned
            </span>
          </div>
        ) : (
          <strong className="text-sm">Unable to assign any trips.</strong>
        )}
        {applyRouteTemplatesResult.unassigned_trips.length > 0 ? (
          <div className="flex flex-col gap-1">
            <span className="text-sm font-medium">Trips not assigned</span>
            <UnassignedTripsDataGrid
              tripsResult={applyRouteTemplatesResult.unassigned_trips}
            />
          </div>
        ) : null}
      </div>

      <ModalFooter>
        <Button onClick={onBack}>Back</Button>
        <Button onClick={handleClose} variant="primary">
          Close
        </Button>
      </ModalFooter>
    </div>
  );
}
